import { getPrepLessons } from '@yandex-int/k-common/client/api/defs/get-prep-lessons';
import { getPrepLessonsDetails } from '@yandex-int/k-common/client/api/defs/get-prep-lessons-details';
import {
    PrepLesson,
    PrepLessonDetails as PrepLessonDetailsServerSide,
    GetPrepLessons,
} from '@yandex-int/k-common/typings';
import { showNetworkError } from 'platform-components';
import { DEFAULT_PAGE_TO_LOAD } from 'platform-components/constants';
import { call, put } from 'redux-saga/effects';
import { all, takeEvery } from 'redux-saga/effects';

import { prepLessonsActions } from './actions';
import { PREP_LESSONS_CHUNK_SIZE } from './constants';

const EMPTY_PREP_LESSONS: PrepLesson[] = [];

export function* prepLessonsSagasWatcher() {
    yield all([
        takeEvery(prepLessonsActions.loadPrepLessonsRequest, loadPrepLessonsSaga),
        takeEvery(prepLessonsActions.loadPrepLessonsDetailsRequest, loadPrepLessonsDetailsSaga),
    ]);
}

function* loadPrepLessonsSaga(action: ReturnType<typeof prepLessonsActions.loadPrepLessonsRequest>) {
    const { themeId, page = DEFAULT_PAGE_TO_LOAD, pageSize = PREP_LESSONS_CHUNK_SIZE } = action.payload;

    try {
        let response: GetPrepLessons = yield call(getPrepLessons, { themeId, page, pageSize });

        const lessons = (response?.results || EMPTY_PREP_LESSONS).map(({ lesson }) => lesson);

        const canLoadMore = (response?.next || null) !== null;

        yield put(prepLessonsActions.loadPrepLessonsSuccess({ lessons, themeId, page, canLoadMore }));
    } catch (error) {
        console.error(error);

        yield put(showNetworkError(error));
        yield put(prepLessonsActions.loadPrepLessonsError({ error, themeId }));
    }
}

function* loadPrepLessonsDetailsSaga(action: ReturnType<typeof prepLessonsActions.loadPrepLessonsDetailsRequest>) {
    yield call(loadPrepLessonsDetails, action.payload);
}

export function* loadPrepLessonsDetails(args: { courseId: number; lessonsIds: number[] }) {
    const { courseId, lessonsIds } = args;
    try {
        yield put(
            prepLessonsActions.loadPrepLessonsDetailsLoading({
                courseId,
                lessonsIds,
            })
        );

        const details: PrepLessonDetailsServerSide[] = yield call(getPrepLessonsDetails, courseId, lessonsIds);

        yield put(
            prepLessonsActions.loadPrepLessonsDetailsSuccess({
                details,
                courseId,
                lessonsIds,
            })
        );
    } catch (error) {
        console.error(error);

        yield put(showNetworkError(error));
        yield put(
            prepLessonsActions.loadPrepLessonsDetailsError({
                error,
                courseId,
                lessonsIds,
            })
        );
    }
}
